import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import styles from "../TaskToDo/styles.module.scss";
import ArrowRight from "@assets/icons/leftArrow";
import { Subtask } from "..";
import { useNavigate } from "react-router-dom";

export interface SubtaskListProps {
  subtasks: Subtask[];
  isTaskDone: boolean;
  onToggleSubtask: (subtaskId: number) => void;
}

export const SubtaskList: React.FC<SubtaskListProps> = ({
  subtasks,
  isTaskDone,
  onToggleSubtask,
}) => {
  const nav = useNavigate();
  const handleSubtask = () => {
    if (!subtasks[0].completed && subtasks[0].title === "Optimize Content") {
      nav("/CRO-module");
    }
  };
  return (
    <div className={styles.subtaskList}>
      {subtasks.map((subtask, index) => {
        const isLocked =
          isTaskDone ||
          index === 0 ||
          (index > 0 &&
            subtasks
              .slice(0, index)
              .every((prevSubtask) => prevSubtask.completed))
            ? false
            : true;
        const isSubtaskDone = isTaskDone || !!subtask.completed;
        const finalDone = isLocked ? false : isSubtaskDone;

        return (
          <div key={subtask.id} className={styles.subtaskItem}>
            <button
              onClick={() => {
                if (!isLocked) {
                  onToggleSubtask(subtask.id);
                }
              }}
              className={`${styles.subtaskCircle} ${
                finalDone ? styles.subtaskCircleDone : ""
              } ${isLocked ? styles.subtaskCircleLocked : ""}`}
            >
              {finalDone && <CheckOutlined className={styles.checkIcon} />}
            </button>
            <div className={styles.subtaskText}>
              <div
                className={
                  finalDone
                    ? styles.subtaskTitleDone
                    : isLocked
                      ? styles.subtaskTitleLocked
                      : styles.subtaskTitle
                }
              >
                {subtask.title}
                {!isTaskDone && index === 0 && (
                  <button
                    onClick={handleSubtask}
                    className={styles.arrowRightRotated}
                  >
                    <ArrowRight />
                  </button>
                )}
              </div>
              {subtask.description && (
                <p
                  className={
                    finalDone
                      ? styles.subtaskDescriptionDone
                      : isLocked
                        ? styles.subtaskDescriptionLocked
                        : styles.subtaskDescription
                  }
                >
                  {subtask.description}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
